module.exports = __webpack_public_path__ + "font/paysera.svg";